export default __webpack_public_path__ + "static/media/staff.78fc7cf2.png";